export default "__VITE_ASSET__BnJ080_j__"